import latestSchema from './v8';

export default latestSchema;
